"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var StaticConfig = {};
StaticConfig.set = function (options) {
  var values = {};
  StaticConfig.meetings = (0, _assign.default)(values, options);
};
var _default = StaticConfig;
exports.default = _default;
//# sourceMappingURL=config.js.map
